// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-dialog{margin-top:50px}#terms-checkboxes .v-messages{min-height:5px}#terms-checkboxes ul li{margin-bottom:5px}.terms-subtitle{font-size:.75rem}", ""]);
// Exports
module.exports = exports;
